import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const StyledAIEditorButton = styled('div')`
  display: flex;
  align-items: center;

  .ai-editor-btn-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ai-editor-btn-text {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkBlue};
    white-space: nowrap;
  }

  .ai-editor-btn-beta {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 480px;
    background: rgba(0, 122, 255, 0.08);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: -0.4px;
    color: #007aff;
    white-space: nowrap;
  }
`;

const StyledAIEditorPopover = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  .coming-soon-text {
    font-weight: 400;
    color: rgba(28, 28, 30, 0.48);
  }
  .popover-menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: default;

    &.active {
      background: ${COLOR.indigo[8]};
    }

    .menu-item-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      color: ${COLOR.darkBlue};
    }

    .menu-item-text {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkBlue};
      white-space: nowrap;
    }

    .info-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      cursor: pointer;
      color: ${COLOR.loadingLoadRequest};

      &:hover {
        color: ${COLOR.darkBlue};
      }
    }
  }
`;

const StyledTooltipContent = styled('span')`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.4px;
  color: ${COLOR.white};

  .tooltip-link {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export { StyledAIEditorButton, StyledAIEditorPopover, StyledTooltipContent };
